import React from 'react';
import { Box, Typography } from '@mui/material';

interface StoryIdeaSectionProps {
  children?: React.ReactNode; // For the prompt component
}

export const StoryIdeaSection: React.FC<StoryIdeaSectionProps> = ({
  children,
}) => {
  return (
    <Box>
      {/* Prompt Section - Always visible, no story selection here */}
      {children && (
        <Box>
          <Typography variant="h6" gutterBottom>
            Story Idea Generation Prompt
          </Typography>
          <Box>{children}</Box>
        </Box>
      )}
    </Box>
  );
};
